import axios from 'axios'

class SecurityService {
  static instance

  constructor() {}

  static singletonInstance() {
    if (!SecurityService.instance) {
      SecurityService.instance = new SecurityService()
    }
    return SecurityService.instance
  }

  async generateKeyPair() {
    return await window.crypto.subtle.generateKey(
      {
        name: 'RSA-OAEP',
        modulusLength: 2048,
        publicExponent: new Uint8Array([1, 0, 1]),
        hash: 'SHA-256'
      },
      true,
      ['encrypt', 'decrypt']
    )
  }

  async exportPublicKey(key) {
    const spki = await window.crypto.subtle.exportKey('spki', key)
    return btoa(String.fromCharCode(...new Uint8Array(spki)))
  }

  async decrypt(privateKey, base64EncryptedMessage) {
    const encrypted = Uint8Array.from(atob(base64EncryptedMessage), c => c.charCodeAt(0))
    const decrypted = await window.crypto.subtle.decrypt({ name: 'RSA-OAEP' }, privateKey, encrypted)
    return new TextDecoder().decode(decrypted)
  }

  async retrieveSensitiveData(uuidv4) {
    const { publicKey, privateKey } = await this.generateKeyPair()
    const exportedPublicKey = await this.exportPublicKey(publicKey)
    const key = await axios.get(`/api/admin/credentials/${uuidv4}`, {
      headers: { 'x-forwarded-token': exportedPublicKey }
    })
    const decrypted = await this.decrypt(privateKey, key.data)
    return decrypted
  }
}

export default SecurityService
